import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { loadUser, refreshToken } from './actions/authAction';
import { loadRoles } from './actions/roleAction';
import jwt_decode from 'jwt-decode'
const token = localStorage.getItem('token');
const user  = token && jwt_decode(token);
if (user) {
  if(user.exp*1000 < Date.now() && localStorage.getItem('remember_me')){
    store.dispatch(refreshToken())
  }
  store.dispatch(loadUser());
  if (user.userType === 'admin' || user.userType === 'subadmin') {
    store.dispatch(loadRoles())
  }
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('wrapper')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
